import { FC, ReactNode, useCallback, useEffect } from 'react';
import { inject, observer } from 'mobx-react';
import { ThemeProvider } from '~/modules';
import { ThemeStore } from '~/stores';

type Props = {
  theme: ThemeStore;
  children: ReactNode;
};

const ThemeProviderContainer: FC<Props> = ({ children, theme }) => {
  const fetchClientProvider = useCallback(() => {
    theme.fetchClientProvider();
  }, [theme]);

  const updateDimensions = () => {
    theme.setDevice(window.innerWidth);
  };

  useEffect(() => {
    fetchClientProvider();
  }, []);

  useEffect(() => {
    updateDimensions();

    window.addEventListener('resize', updateDimensions);

    return () => window.removeEventListener('resize', updateDimensions);
  }, []);

  return <ThemeProvider theme={theme.theme}>{children}</ThemeProvider>;
};

export default inject('theme')(observer(ThemeProviderContainer));
